// AiThreadRootMessage.jsx — render feed/surface/ai_text root in thread panel

import React from 'react';

// Constants
import { MESSAGE_TYPES } from 'spaces/constants/aiConstants';

// Components
import AiFeedItemMessage from 'spaces/components/AiFeedItemMessage';
import AiMessageRow from 'spaces/components/AiMessageRow';
import AiSurfaceMessage from 'spaces/components/AiSurfaceMessage';

const AiThreadRootMessage = React.memo(({ message }) => {
  const messageType = String(message?.messageType || '').trim();

  if (messageType === MESSAGE_TYPES.AI_FEED_ITEM) {
    return <AiFeedItemMessage message={message} />;
  }

  if (messageType === MESSAGE_TYPES.AI_SURFACE) {
    return <AiSurfaceMessage message={message} />;
  }

  if (messageType === MESSAGE_TYPES.AI_TEXT) {
    return <AiMessageRow message={message} />;
  }

  // ----- RENDER ----- //

  return null;
});

// Dev Tools
AiThreadRootMessage.displayName = 'AiThreadRootMessage';

export default AiThreadRootMessage;
